module.exports = __webpack_public_path__ + "static/media/energy_kpi.ce0ba0aa.pdf";